export default __webpack_public_path__ + "static/media/logo-white.29ac0bec.svg";